import {Container, Row, Col} from 'react-bootstrap';
import {CheckBox, Header, NonIdealScreen, ToastBox} from '../../../../common';
import TableHeader from '../../../../common/TableContainer/TableHeader';
import {useAuthContext, useLanguageContext, useThemeContext} from '../../../../../context';
import Icon from '../../../../../assets/icons';
import {DEVICE_HEIGHT} from '../../../../../constants';
import {useNavigate} from 'react-router-dom';
import {observeArchivedPO, observeCreatedAndDraftPO, searchPO} from '../../../../../pos-core/database/helpers';
import withObservables from '@nozbe/with-observables';
import {useSearch} from '../../../../../hooks';
import List from './List';
import useFilter from '../../../../../hooks/useFilter';
import {useEffect, useState} from 'react';
import usePermission from '../../../../../hooks/usePermission';

const PurchaseOrderList = ({purchaseOrders, archived}) => {
    let navigate = useNavigate();
    const {I18n} = useLanguageContext();
    const {theme} = useThemeContext();

    const {text, setText, searchList} = useSearch(handleSearch);
    const {filteredList, setOption, option} = useFilter(handleFilter, archived);

    const sortedPO = purchaseOrders.sort((a, b) => b.created_at - a.created_at);

    const {renderToast, setRenderToast} = useAuthContext();
    const [showMessage, setShowMessage] = useState({
        visible: false,
        message: '',
    });
    const userPermission = usePermission('purchaseorder');

    useEffect(() => {
        if (showMessage.visible) {
            const timeoutId = setTimeout(() => {
                setShowMessage({
                    visible: false,
                    message: '',
                });
                setRenderToast('');
            }, 3000);
            return () => clearTimeout(timeoutId);
        }
    }, [showMessage]);

    useEffect(() => {
        if (renderToast === 'po_created') {
            setShowMessage({
                visible: true,
                message: I18n.po_created_successfully,
            });
        } else if (renderToast === 'po_saved_into_draft') {
            setShowMessage({
                visible: true,
                message: I18n.po_saved_into_draft,
            });
        } else if (renderToast === 'po_rejected') {
            setShowMessage({
                visible: true,
                message: I18n.po_rejected,
            });
        } else if (renderToast === 'po_pending') {
            setShowMessage({
                visible: true,
                message: I18n.po_pending,
            });
        } else if (renderToast === 'po_approved') {
            setShowMessage({
                visible: true,
                message: I18n.po_approved,
            });
        }
    }, [renderToast]);
    function handleSearch(val) {
        return searchPO(val.toLowerCase());
    }

    const onChange = (event, key) => {
        let value = key || event?.target?.value || '';
        setText(value);
    };

    const handleCreatePO = async () => {
        navigate('/purchaseorder/create');
    };
    function handleFilter(selected) {
        if (selected == 'all') {
            setOption('');
            return sortedPO;
        } else {
            setOption(selected);
            return selected == 'archived' ? archived : sortedPO.filter(x => x.status.toLowerCase() === selected.toLowerCase());
        }
    }

    const filterOption = [
        {
            title: I18n.all,
            action: () => handleFilter('all'),
            checked: option === 'all' || option === '' ? true : false,
        },
        {
            title: I18n.cancel,
            action: () => handleFilter('rejected'),
            checked: option === 'rejected' ? true : false,
        },
        {
            title: I18n.draft,
            action: () => handleFilter('draft'),
            checked: option === 'draft' ? true : false,
        },
        {
            title: I18n.pending,
            action: () => handleFilter('pending'),
            checked: option === 'pending' ? true : false,
        },
        {
            title: I18n.received,
            action: () => handleFilter('approved'),
            checked: option === 'approved' ? true : false,
        },
        {
            title: I18n.archived,
            action: () => handleFilter('archived'),
            checked: option === 'archived' ? true : false,
        },
    ];

    return sortedPO.length ? (
        <div className="pad20" style={{backgroundColor: theme.topBarBG}}>
            <Header
                type="search"
                leftCta={{
                    title: I18n.purchase_order,
                    name: 'downIcon',
                    fill: theme.white,
                    width: '12',
                    height: '9',
                    viewBox: '0 0 8 5',
                    option: filterOption,
                }}
                title={`${I18n.purchase_order} (${sortedPO.length})`}
                search={{
                    type: 'pos',
                    placeholder: I18n.search_vendor_order_no,
                    prefix: {
                        name: 'search2Icon',
                        fill: theme.white,
                    },
                    onChange: onChange,
                }}
                className={'borderRadiusTopleftTopRigt'}
                rightCta={userPermission?.canCrud ? {title: I18n.create_po, action: handleCreatePO} : null}
            />

            <div className="tableListMainBox borderRadiusBottomleftBottomRigt" fluid style={{background: theme.blackBg, height: DEVICE_HEIGHT - 180}}>
                <Container fluid>
                    <Row>
                        <Col>
                            <TableHeader className={`eightColumn`} style={{borderColor: theme.posRightBg}}>
                                <div className="BoxWidth justifyStart">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.po_num}
                                    </p>
                                </div>
                                <div className="BoxWidth justifyCenter">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.status}
                                    </p>
                                </div>
                                <div className="BoxWidth justifyCenter">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.purchase_date}
                                    </p>
                                </div>
                                <div className="BoxWidth justifyCenter">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.expected_on}
                                    </p>
                                </div>
                                <div className="BoxWidth justifyCenter">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.vendor}
                                    </p>
                                </div>
                                <div className="BoxWidth justifyCenter">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.ship_to}
                                    </p>
                                </div>
                                <div className="BoxWidth justifyCenter">
                                    <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                        {I18n.amount}
                                    </p>
                                </div>

                                {userPermission?.canCrud && (
                                    <div className="BoxWidth justifyCenter">
                                        <p className="fontSize16 OneLineTruncate" style={{color: theme.white}}>
                                            {I18n.action}
                                        </p>
                                    </div>
                                )}
                            </TableHeader>

                            <div style={{height: DEVICE_HEIGHT - 280}} className="tableListMainBox">
                                {(text ? searchList : option ? filteredList : sortedPO).map(val => (
                                    <List item={val} userPermission={userPermission} />
                                ))}
                            </div>
                            <ToastBox
                                className="addSuccessfullyToast"
                                ToastVisiable={showMessage.visible}
                                bodyPara={showMessage.message}
                                setShowMessage={setShowMessage}
                                showIcon={true}
                            />
                        </Col>
                    </Row>
                </Container>
            </div>
        </div>
    ) : (
        <NonIdealScreen
            heading={I18n.purchase_order}
            subHeading={I18n.create_purchase_order_and_manage_inventory}
            name="purchaseOrderNewIon"
            fill={theme.white}
            secondaryCta={
                userPermission?.canCrud
                    ? {
                          title: I18n.create_po,
                          action: handleCreatePO,
                      }
                    : null
            }
            isMultiStep={false}
        />
    );
};

const enhance = withObservables([], () => ({
    purchaseOrders: observeCreatedAndDraftPO(),
    archived: observeArchivedPO(),
}));

export default enhance(PurchaseOrderList);
